/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SOffenderRecordsReport
 */
export interface SOffenderRecordsReport {
    /**
     * 
     * @type {string}
     * @memberof SOffenderRecordsReport
     */
    report_s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof SOffenderRecordsReport
     */
    report_access_url?: string;
}

/**
 * Check if a given object implements the SOffenderRecordsReport interface.
 */
export function instanceOfSOffenderRecordsReport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SOffenderRecordsReportFromJSON(json: any): SOffenderRecordsReport {
    return SOffenderRecordsReportFromJSONTyped(json, false);
}

export function SOffenderRecordsReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SOffenderRecordsReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report_s3_key': !exists(json, 'report_s3_key') ? undefined : json['report_s3_key'],
        'report_access_url': !exists(json, 'report_access_url') ? undefined : json['report_access_url'],
    };
}

export function SOffenderRecordsReportToJSON(value?: SOffenderRecordsReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_s3_key': value.report_s3_key,
        'report_access_url': value.report_access_url,
    };
}

